import { axiosInstance } from "../../../axios/axiosInstance";

const API_WALLET_MANAGEMENT_URL = "admin/wallet";
const API_WALLET_MANAGEMENT_MODULE_LIST_URL =
  API_WALLET_MANAGEMENT_URL + "/wallet_list";
const API_ADD_FUND_TO_WALLET_MANAGEMENT_URL =
  API_WALLET_MANAGEMENT_URL + "/add_fund";

export const getWalletManagement = (dataToBeSent) => {
  return axiosInstance.post(
    API_WALLET_MANAGEMENT_MODULE_LIST_URL +
      `?search=${dataToBeSent.search ? dataToBeSent.search : ""}&page=${
        dataToBeSent.page ? dataToBeSent.page : ""
      }&size=${dataToBeSent.limit ? dataToBeSent.limit : ""}&filters[role]=${dataToBeSent?.role || ""}`
  );
};

export const addFundToWallet = (dataToBeSent) => {
  return axiosInstance.post(
    API_ADD_FUND_TO_WALLET_MANAGEMENT_URL,
    dataToBeSent
  );
};
